module.exports = __webpack_public_path__ + "img/orange_050.d28881ec.png";